export default {
  impressions: {
    short: 'cpm',
    text: 'Cost Per Mile (CPM)'
  },
  clicks: {
    short: 'cpc',
    text: 'Cost Per Click (CPC)'
  },
  videos: {
    short: 'cpv',
    text: 'Cost Per View (CPV)'
  },
  actions: {
    short: 'cpa',
    text: 'Optimize For CPA'
  }
}